query allCustomersQueryTotalCount(
  $first: Int
  $offset: Int
  $condition: AccountCondition
  $filter: AccountFilter
) {
  allCustomers: allAccounts(
    first: $first
    offset: $offset
    condition: $condition
    filter: $filter
  ) {
    totalCount
  }
}
